"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendReadStatusToServer = void 0;
var effector_1 = require("effector");
var QBAdapter = __importStar(require("../QBAdapter"));
var logger_1 = __importDefault(require("../logger"));
var log = logger_1.default.module('Messages.sendReadStatus');
exports.sendReadStatusToServer = effector_1.createEffect().use(QBAdapter.sendReadStatus);
exports.default = (function (Messages$, sendReadStatus, getSession) {
    effector_1.forward({
        from: sendReadStatus,
        to: exports.sendReadStatusToServer,
    });
    Messages$.on(sendReadStatus, function (state, _a) {
        var _b;
        var messageId = _a.messageId;
        var user_id = getSession().user_id;
        var message = state[messageId];
        if (!message) {
            log.warn('Change read status: message doesnt exist at store', {
                messageId: messageId,
            });
            return state;
        }
        if (!user_id) {
            log.warn('Change read status: user_id doesnt exist at store', {
                messageId: messageId,
            });
            return state;
        }
        var updMessage = __assign(__assign({}, message), { read_ids: __spreadArrays(message.read_ids, [user_id]) });
        return __assign(__assign({}, state), (_b = {}, _b[messageId] = updMessage, _b));
    });
});
//# sourceMappingURL=sendReadStatus.js.map